<template>
  <Container class="container-sm-none">
    <Card class="card-shadow">
      <div class="width-lg">
        <div class="pl-10 pl-md-0 pr-10 pr-md-0">
          <IconDocument />
          <div>
          <h2 class='weight-medium mt-20'>
            "The SMS was successfully sent.
          </h2>
          <p class='body-2 weight-regular mt-10'>
            The link to start the process has been successfully sent to your phone number, or you can start the process by scanning the QR code below.
          </p>
          </div>

          <div class='mt-20'>
            <img :src='qrCodeSrc' alt='QR-KÓD' width='150px' height='auto'/>
          </div>

          <InfoBox class="mt-5 ib-warning" :icon="require('@/assets/svg/alert-icon.svg')">
            <p class="m-0 pr-md-5 weight-regular body-3">
              You can close the browser window.
            </p>
          </InfoBox>
        </div>
      </div>
    </Card>
  </Container>
</template>

<script>
import IconDocument from '@/components/Icons/IconDocument.vue';
import Card from '@/components/Card/Card.vue';
import Container from '@/components/Container/Container.vue';
import InfoBox from '@/components/InfoBox/InfoBox.vue';

export default {
  name: 'SmsThankYouPage.vue',
  components: {
    InfoBox,
    Container,
    Card,
    IconDocument,
  },
  props: {
    model: { type: Object, required: true },
  },
  created() {
    this.$router.maxStep = 23;
    this.model.step = 23;
    if (this.model.lastStep < 23) this.model.lastStep = 23;
  },
  computed: {
    qrCodeSrc() { return `data:image/jpg;base64, ${this.model.prepareTransactionData.qrCodeBase64}`; },
  },
};
</script>
